var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.symbol === '$')?[_vm._v("\n        "+_vm._s(_vm.symbol)+_vm._s(_vm.formattedPrice)+"\n    ")]:[_vm._v("\n        "+_vm._s(_vm.formattedPrice)+" "),_c('span',{staticClass:"ui-format-price__symbol"},[_vm._v(_vm._s(_vm.symbol))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }